<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h2 class="mb-3">{{ page.title }}</h2>
          <div v-html="page.description"></div>
          <button class="btn btn-primary mt-4" @click="goTo">
            {{ page.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        page: window.errorPage,
      };
    },
    methods: {
      goTo() {
        this.$router.push(this.$route.params.pathMatch + this.page.buttonLink);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .btn {
    height: 52px;
    width: 160px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
</style>
